import { IInterceptorIO, TInfoIO } from '../../../core/interceptor';
import { CookieAdapterIO } from '../../../adapters/cookie';
import { RequestAPI } from '../../../adapters/api';

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export type t_authorization_type = 'digest' | 'bearer' | 'csrf' | 'session';

const lens = {
  authorization: f1.lens('/options/authorization'),
  token: f1.lens('/options/token'),
  headers: f1.lens('/packet/headers')
};

const headerKeys = {
  authorization: 'Authorization',
  csrfToken: 'x-csrftoken'
};

export class APIRequestAuthorization implements IInterceptorIO<RequestAPI> {
  readonly id = 'api-authorization';
  readonly type = 'request';

  private readonly __iioCookie = new CookieAdapterIO();

  async transform(infoIO: TInfoIO<RequestAPI>) {
    const authorizationType = f1.read(lens.authorization, 'csrf' as t_authorization_type, infoIO);
    const headers = f1.read(lens.headers, {}, infoIO);
    const token = f1.read(lens.token, '', infoIO);

    delete headers[headerKeys.authorization];
    delete headers[headerKeys.csrfToken];

    switch (authorizationType) {
      case 'csrf':
        headers[headerKeys.csrfToken] = this.__iioCookie.query('/csrftoken');
        break;
      case 'bearer':
        headers[headerKeys.authorization] = `Bearer ${token}`;
        break;
      case 'digest':
        headers[headerKeys.authorization] = `Token ${token}`;
        break;
      case 'session':
        break;
      default:
        break;
    }

    return f1.write(lens.headers, headers, infoIO) as TInfoIO<RequestAPI>;
  }
}
